<div class="grid">
    <ag-grid-angular
        style="width: 100%; height: 100%"
        class="ag-theme-quartz"
        [gridOptions]="gridOptions()"
        [cacheBlockSize]="cacheBlockSize()"
        [maxBlocksInCache]="maxBlocksInCache()"
        [rowBuffer]="rowBuffer()"
        [columnDefs]="colDefs()"
        [defaultColDef]="defaultColDef()"
        [columnTypes]="columnTypes"
        [autoSizeStrategy]="autoSizeStrategy()"
        [theme]="theme"
        [noRowsOverlayComponent]="CustomNoRowsOverlay"
        [noRowsOverlayComponentParams]="overlayParams()"
        (gridReady)="onGridReady($event)"
        (firstDataRendered)="onFirstDataRendered()"
        [rowHeight]="42"
    ></ag-grid-angular>
</div>
